var firstSlide = document.getElementById('slide-1');

function setInitialDimensions () {
  var player = document.getElementById('player');
  var stage = document.querySelector('.mobile-stage');
  var slideContainer = document.querySelector('.mobile-stage .slide_container');

  if (player.classList.contains('infographic_player')) return
   
  var aspectRatio = firstSlide.naturalHeight / firstSlide.naturalWidth;
  
  // Margins are at minimum 28px (14px on each side)
  var newHeight = (window.innerWidth - 28) * aspectRatio;

  if (newHeight > firstSlide.naturalHeight) {
    newHeight = firstSlide.naturalHeight;
  }
  player.style.height = (newHeight + 20) + 'px'; // Takes vertical padding into account

  var actualHeight = stage.offsetHeight;
  var newMarginLeft = (window.innerWidth - actualHeight / aspectRatio) / 2;

  // Set margin left of entire container
  slideContainer.style.marginLeft = newMarginLeft + 'px';

  // Set margin left of slide first slide
  firstSlide.style.marginRight = (newMarginLeft / 2) + 'px';
}

if (firstSlide.complete) {
  setInitialDimensions();
}
else {
  firstSlide.addEventListener('load', function () {
    setInitialDimensions();
  })
}